module.exports = __webpack_public_path__ + "img/fes.946055f7.png";